import { TCheckUniqOrganisations } from '@interfaces/components/form';

export const tabsNames = {
	basicInfo: 'basicInfo',
	address: 'address',
	organisationType: 'organisationType',
	roleAvailability: 'roleAvailability',
};

export const basicInfoAreas = (isSettings: boolean) => `
		"name logo"
		"legalName logo"
		"website website"
		"email contactNumber"
		"companyNumber ${isSettings ? 'companyNumber' : 'timezone'}"
		"submitButton submitButton"
		`;

export const addressAreas = `
		"property streetName"
		"locality city"
		"postcode country"
		"timezone ."
		"buttons buttons"
		`;

export const defaultValuesCheckErrors: TCheckUniqOrganisations = {
	nameError: undefined,
	legalNameError: undefined,
	emailError: undefined,
};

export const fieldsToTestBasicInfo = [
	'name',
	'legalName',
	'url',
	'uprn',
	'email',
	'contactNumber',
	'timezone',
];

export const fieldsToTestAddress = [
	'property',
	'streetName',
	'locality',
	'city',
	'postcode',
	'country',
];

export const fieldsToTestOrganisationType = [
	'organizationTelecomId',
];

export const organisationTelecomIdTooltip = 'The Organization telecom ID, will be Used to map bounding telecom Sites to Organization on the Platform. Numbers, letters and -, _ are allowed only.';

export const blockTooltipTextForPlatformOwner = 'To proceed to the next step select the organisation type';

export const questionRevokedRoles = `There are previously used User roles in the backup.
						Do you want to restore User roles from the backup?`;
